/* eslint-disable @typescript-eslint/no-explicit-any */
import { Delete, Get, Patch, Post } from "./apiHelper";
import { ILeaveType } from "../interfaces/LeaveInterface";
import { ApiResponse } from "../interfaces/Api";

const leaveRoot = "/api/leaveTypes";

// get leave types
export async function getLeaveTypes({
  resourceCentreId
}: {
  resourceCentreId: number;
}): Promise<ApiResponse<Array<ILeaveType>>> {
  const searchParams = new URLSearchParams();
  searchParams.append("resourceCentreId", resourceCentreId.toString());

  const response = await Get(`${leaveRoot}?${searchParams.toString()}`, true);
  return response.data as ApiResponse<Array<ILeaveType>>;
}

// post leave type
export async function postLeaveType(data: Partial<ILeaveType>): Promise<ApiResponse<ILeaveType>> {
  const response = await Post(`${leaveRoot}`, data as any, true);
  return response.data as ApiResponse<ILeaveType>;
}

// patch leave type
export async function patchLeaveType({
  id,
  data
}: {
  id: number | string;
  data: Partial<ILeaveType>;
}): Promise<ApiResponse<ILeaveType>> {
  const response = await Patch(`${leaveRoot}/${id}`, data as any, true);
  return response.data as ApiResponse<ILeaveType>;
}

// delete leave type
export async function deleteLeaveType(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${leaveRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
